import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthContextProvider } from './store/AuthContext';
import 'react-toastify/dist/ReactToastify.css';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { ThemeProvider } from './store/ThemeContext';
import IdleWrapper from './utils/IdleWrapper';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <AuthContextProvider>
      <IdleWrapper>
        <App />
      </IdleWrapper>
    </AuthContextProvider>
  </ThemeProvider>
);
